import { useTranslation } from 'react-i18next';

type CompletedProps = {
  questionid: string;
  questionHeading: string;
  questionText: string;
  assessmentValues: any;
};
export function Completed({
  questionid,
  questionHeading,
  questionText,
  assessmentValues,
}: CompletedProps) {
  const { t } = useTranslation();
  return (
    <div className="question_container" id={questionid}>
      <div style={{ display: 'block', width: '100%' }}>
        <h1>{questionHeading}</h1>
      </div>
      <div style={{ display: 'block', width: '100%' }}>
        <p>{questionText}</p>
      </div>
      <a href="/individual-report/overview">{t('A115')}</a>
      {JSON.stringify(assessmentValues)}
    </div>
  );
}
